<script>
    export let title = '';
    export let itemCountTitle = '';
    export let itemCount = null;

    function getSingularForm(word) {
        // Special cases
        if (word.toLowerCase().endsWith('studies')) return word.slice(0, -3) + 'y';
        if (word.toLowerCase().endsWith('devices')) return word.slice(0, -1);
        if (word.toLowerCase().endsWith('entries')) return word.slice(0, -3) + 'y';
        // General cases
        return word.replace(/(?:ies|s)$/, '');
    }

    $: formattedTitle = itemCount === 1 
        ? getSingularForm(itemCountTitle)
        : itemCountTitle;
</script>

<div class="flex justify-between mt-3 mb-0 mx-1 bg-stone-200/50 dark:bg-gray-800/90 p-2 px-4 rounded-t-lg toolbar-print">
    <h2 class="text-m text-black dark:text-white flex items-baseline">{title}</h2>
    <div class="flex text-m mb-0 gap-4 items-baseline text-black dark:text-white toolbar-print-items">
        <!-- Slot for filters/actions -->
        <slot />
        
        {#if itemCount !== null}
            <span class="flex items-baseline">{itemCount} {formattedTitle}</span>
        {/if}
    </div>
</div>